import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { banners } from "@/mocks/banners";

export default function HeroCarousel() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index: number) => {
    setCurrent((index + banners.length) % banners.length);
  };

  return (
    <section className="relative w-full h-[460px] md:h-[600px] overflow-hidden bg-primary-900">
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={banner.image}
              alt={`${banner.title} 韩漫推荐`}
              title={`${banner.title} 无删减韩漫在线阅读`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/10"></div>
          <div className="relative w-full h-full flex items-center">
            <div className="w-full px-6 md:px-16 lg:px-20">
              <div className="max-w-xl">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium mb-4">
                  <i className="ri-fire-fill"></i>
                  {banner.tag}
                </span>
                <h2 className="font-heading font-bold text-white text-3xl md:text-5xl leading-tight">
                  {banner.title}
                </h2>
                <p className="text-white/70 text-sm md:text-base mt-1">
                  {banner.subTitle}
                </p>
                <p className="text-white/85 text-sm md:text-base mt-4 leading-relaxed line-clamp-2 md:line-clamp-3">
                  {banner.description}
                </p>
                <div className="flex flex-wrap items-center gap-3 mt-7">
                  <button
                    type="button"
                    onClick={() => navigate(`/detail/${banner.comicId}`)}
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-white text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-book-read-line"></i>
                    立即阅读
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate(`/detail/${banner.comicId}`)}
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-white/10 text-white text-sm font-medium border border-white/30 whitespace-nowrap hover:bg-white/20 transition-colors cursor-pointer"
                  >
                    查看详情
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => goTo(current - 1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-5 top-1/2 -translate-y-1/2 w-10 h-10 items-center justify-center rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        onClick={() => goTo(current + 1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-5 top-1/2 -translate-y-1/2 w-10 h-10 items-center justify-center rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((banner, index) => (
          <button
            key={banner.id}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => goTo(index)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              index === current ? "w-7 bg-accent-500" : "w-2 bg-white/50"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}